import { InsurancePackageType } from '@/@types/insurance';
import { ProductType } from '@/@types/product';

// Article IDs
export const PACKAGE_S_MONTHLY_ID = '6620';
export const PACKAGE_M_MONTHLY_ID = '6621';
export const PACKAGE_L_MONTHLY_ID = '6622';
// yearly
export const PACKAGE_S_YEARLY_ID = '6623';
export const PACKAGE_M_YEARLY_ID = '6624';
export const PACKAGE_L_YEARLY_ID = '6625';

// Configuration IDs
export const DISCOUNTED_MONTHLY_CONFIG_ID = 'c3d1a9be-a892-464c-bcdd-abda29311b35';
export const DISCOUNTED_YEARLY_CONFIG_ID = '20354d7a-e4fe-47af-8ff6-187bca92f3f9';
// Tenant config IDs - July/2025
export const TENANT_MONTHLY_CONFIG_ID = 'a8f2c5e7-3b9d-4f1a-8e6c-2d4b7a9f1c8e';
export const TENANT_YEARLY_CONFIG_ID = 'b7e3f8a2-5c1d-4a9e-8f2b-6d5a9c7e4f1b';
// Upsell config IDs
export const TENANT_UPSELL_CONFIG_ID = 'd3c8f1e5-9a2b-4d7f-8e1c-5b6a8d2f4e9c';
export const DISCOUNT_UPSELL_CONFIG_ID = 'b1d9a9be-c892-464c-acdd-abda29311b35';

// Experimental Configuration IDs Aug 2025
export const EXPERIMENTAL_DISCOUNTED_MONTHLY_CONFIG_ID = '82725100-8201-4822-a3d5-2dcb34e85247';
export const EXPERIMENTAL_DISCOUNTED_YEARLY_CONFIG_ID = '3bdeea76-2cf8-4dc1-8b6b-3aafc8833795';
// Experimental Upsell config IDs Aug 2025
export const EXPERIMENTAL_PRICE_DECREASE_UPSELL_CONFIG_ID = '87f57400-bf37-4042-b440-3a2ac5acab7d';

// Discount Percentages
export const TENANT_DISCOUNT_PERCENTAGE = 15;
export const DISCOUNTED_DISCOUNT_PERCENTAGE = 30;
export const EXPERIMENTAL_DISCOUNT_PERCENTAGE = 50;

export const WOHNEN_UPSELL = {
  ARTICLE_IDS: {
    MONTHLY: PACKAGE_S_MONTHLY_ID,
    YEARLY: PACKAGE_S_YEARLY_ID,
  },
  CONFIGURATION_IDS: {
    DISCOUNTED: {
      MONTHLY: DISCOUNTED_MONTHLY_CONFIG_ID,
      YEARLY: DISCOUNTED_YEARLY_CONFIG_ID,
      DISCOUNT_PERCENTAGE: DISCOUNTED_DISCOUNT_PERCENTAGE,
      MAX_VALUE: 6.99,
    },
    TENANT: {
      MONTHLY: TENANT_MONTHLY_CONFIG_ID,
      YEARLY: TENANT_YEARLY_CONFIG_ID,
      DISCOUNT_PERCENTAGE: TENANT_DISCOUNT_PERCENTAGE,
      MAX_VALUE: 8.49,
    },
    UPSELL: {
      TENANT: TENANT_UPSELL_CONFIG_ID,
      DISCOUNT: DISCOUNT_UPSELL_CONFIG_ID,
      EXPERIMENTAL_DISCOUNT: EXPERIMENTAL_PRICE_DECREASE_UPSELL_CONFIG_ID,
    },
    DISCOUNTED_EXPERIMENTAL: {
      MONTHLY: EXPERIMENTAL_DISCOUNTED_MONTHLY_CONFIG_ID,
      YEARLY: EXPERIMENTAL_DISCOUNTED_YEARLY_CONFIG_ID,
      DISCOUNT_PERCENTAGE: EXPERIMENTAL_DISCOUNT_PERCENTAGE,
      MAX_VALUE: 4.99,
    },
  },
  PACKAGE_TYPES: {
    [PACKAGE_S_MONTHLY_ID]: InsurancePackageType.PACKAGE_S,
    [PACKAGE_M_MONTHLY_ID]: InsurancePackageType.PACKAGE_M,
    [PACKAGE_L_MONTHLY_ID]: InsurancePackageType.PACKAGE_L,
    [PACKAGE_S_YEARLY_ID]: InsurancePackageType.PACKAGE_S,
    [PACKAGE_M_YEARLY_ID]: InsurancePackageType.PACKAGE_M,
    [PACKAGE_L_YEARLY_ID]: InsurancePackageType.PACKAGE_L,
  } as const,
  PAYMENT_FREQUENCY: {
    [PACKAGE_S_MONTHLY_ID]: 'MONTHLY',
    [PACKAGE_M_MONTHLY_ID]: 'MONTHLY',
    [PACKAGE_L_MONTHLY_ID]: 'MONTHLY',
    [PACKAGE_S_YEARLY_ID]: 'YEARLY',
    [PACKAGE_M_YEARLY_ID]: 'YEARLY',
    [PACKAGE_L_YEARLY_ID]: 'YEARLY',
  } as const,
  PRODUCT_TYPE: ProductType.WohnenPlus,
} as const;
